(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bd-authorized-retailers"] && !Shopify.designMode) return;
  try {
    
	// console.log('1st retailer test');
	$('[data-toggle-btn]').on('click', function () {
		var target = $(this);
		// console.log('retailer test',target);
		$(target).toggleClass('active').next().slideToggle(500);
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product--recommendations"]) return;
  try {
    
	var loadProductRecommendationsIntoSection = function () {
		var productRecommendationsSection = document.querySelector('.product-recommendations');
		if (productRecommendationsSection === null) {
			return;
		}
		var productId = productRecommendationsSection.dataset.productId;
		var limit = productRecommendationsSection.dataset.limit;
		var requestUrl =
			Shopify.routes.root +
			'/recommendations/products?section_id=product--recommendations&limit=' +
			limit +
			'&product_id=' +
			productId;
		var request = new XMLHttpRequest();
		request.open('GET', requestUrl);
		request.onload = function () {
			if (request.status >= 200 && request.status < 300) {
				var container = document.createElement('div');
				container.innerHTML = request.response;
				productRecommendationsSection.parentElement.innerHTML =
					container.querySelector('.product-recommendations').innerHTML;
			}
		};
		request.send();
	};
	document.addEventListener('shopify:section:load', function (event) {
		if (event.detail.sectionId === 'product-recommendations') {
			loadProductRecommendationsIntoSection();
		}
	});
	loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-collection-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.RCCSCollectionStory&&window.RCCSCollectionStory.initWithin){
    window.RCCSCollectionStory.initWithin(document);
    return;
  }

  var instances=new WeakMap();

  function rootsWithin(scope){
    var roots=[];
    if(scope&&scope.matches&&scope.matches('[data-rccs]'))roots.push(scope);
    if(scope&&scope.querySelectorAll)scope.querySelectorAll('[data-rccs]').forEach(function(root){roots.push(root);});
    return roots;
  }

  function init(root){
    if(!root||instances.has(root))return;

    var cleanups=[];
    var observers=[];
    var timers=new Set();
    var frames=new Set();
    var destroyed=false;
    var reduceQuery=window.matchMedia('(prefers-reduced-motion: reduce)');
    var reduce=reduceQuery.matches;
    var mobileQuery=window.matchMedia('(max-width:860px)');
    var selectCraftStep=null;
    var selectHotspotSilently=null;
    var placeSwatchesForBreakpoint=null;

    /* Whatever is pinned across the top of the viewport - this section's sticky bar AND the
       theme's own sticky header, whose height cannot be known from in here - has to be cleared,
       or an in-page CTA lands its target underneath it and hotspot focus scrolls under it too. */
    function topObstruction(){
      var lowest=0;
      var bar=root.querySelector('[data-topbar]');
      if(bar&&getComputedStyle(bar).visibility!=='hidden')lowest=bar.getBoundingClientRect().bottom;
      if(document.elementsFromPoint){
        var stack=document.elementsFromPoint(Math.round(window.innerWidth/2),4);
        for(var i=0;i<stack.length;i++){
          var el=stack[i];
          if(root.contains(el))continue;
          var cs=getComputedStyle(el);
          if(cs.position!=='fixed'&&cs.position!=='sticky')continue;
          var r=el.getBoundingClientRect();
          /* Only a genuine top bar: touching the top edge, and not a full-screen overlay. */
          if(r.top<=1&&r.height>0&&r.height<=280){lowest=Math.max(lowest,r.bottom);break;}
        }
      }
      return Math.max(0,Math.min(lowest,280));
    }

    /* Feed the measured height into scroll-margin-top so anchor jumps clear the real header
       rather than a hardcoded guess. Re-measured on resize; falls back to the CSS default. */
    function syncScrollOffset(){
      root.style.setProperty('--rccs-scroll-offset',(topObstruction()+16)+'px');
    }
    var craftPinned=null;
    var reduceHandlers=[];
    root.classList.add('rccs--js');

    function listen(target,type,handler,options){
      if(!target)return;
      target.addEventListener(type,handler,options);
      cleanups.push(function(){target.removeEventListener(type,handler,options);});
    }

    listen(reduceQuery,'change',function(event){
      reduce=event.matches;
      reduceHandlers.forEach(function(handler){handler(reduce);});
      onScroll();
    });

    function later(handler,delay){
      var id=window.setTimeout(function(){
        timers.delete(id);
        if(!destroyed)handler();
      },delay);
      timers.add(id);
      return id;
    }

    function frame(handler){
      var id=window.requestAnimationFrame(function(time){
        frames.delete(id);
        if(!destroyed)handler(time);
      });
      frames.add(id);
      return id;
    }

    function revealElements(){
      var reveal=root.querySelectorAll('.rccs-reveal');
      if(!('IntersectionObserver' in window)){
        reveal.forEach(function(el){el.classList.add('is-in');});
        return;
      }
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },{threshold:.14});
      observers.push(observer);
      reveal.forEach(function(el){observer.observe(el);});
    }

    revealElements();

    var hero=root.querySelector('[data-hero]');
    if(hero){
      var showHero=function(){hero.classList.add('is-in');};
      frame(function(){later(showHero,100);});
      if(document.readyState==='complete')showHero();
      else listen(window,'load',showHero,{once:true});
    }

    var craft=root.querySelector('[data-craft]');
    if(craft){
      var craftMedia=craft.querySelectorAll('.rccs-craft__mediaitem');
      var craftSteps=craft.querySelectorAll('.rccs-craft__step');
      var craftDots=craft.querySelectorAll('.rccs-craft__prog span');
      var craftCurrent=-1;
      selectCraftStep=function(index){
        if(!craftSteps.length)return;
        var next=Math.max(0,Math.min(index,craftSteps.length-1));
        if(next===craftCurrent)return;
        craftCurrent=next;
        craftMedia.forEach(function(media){media.classList.toggle('is-on',+media.dataset.step===next);});
        craftSteps.forEach(function(step){
          step.classList.toggle('is-on',+step.dataset.step<=next);
          step.classList.toggle('is-current',+step.dataset.step===next);
        });
        craftDots.forEach(function(dot,dotIndex){dot.classList.toggle('is-on',dotIndex<=next);});
      };
      selectCraftStep(0);
      var glow=craft.querySelector('[data-glow]');
      var sticky=craft.querySelector('.rccs-craft__sticky');
      if(glow&&sticky&&window.matchMedia('(pointer:fine)').matches){
        listen(sticky,'pointermove',function(event){
          if(reduce){
            glow.style.opacity='0';
            return;
          }
          var rect=sticky.getBoundingClientRect();
          glow.style.left=(event.clientX-rect.left)+'px';
          glow.style.top=(event.clientY-rect.top)+'px';
          glow.style.opacity='1';
        });
        listen(sticky,'pointerleave',function(){glow.style.opacity='0';});
        reduceHandlers.push(function(isReduced){if(isReduced)glow.style.opacity='0';});
      }
    }

    var explorer=root.querySelector('[data-explorer]');
    if(explorer){
      var explorerMedia=explorer.querySelectorAll('[data-expmedia]');
      var swatches=explorer.querySelectorAll('[data-expswatches] .rccs-swatch');
      var explorerTag=explorer.querySelector('[data-expidx]');
      var explorerName=explorer.querySelector('[data-expname]');
      var explorerDescription=explorer.querySelector('[data-expdesc]');
      var explorerShop=explorer.querySelector('[data-expshop]');
      var explorerCount=explorer.querySelector('[data-expcount]');
      var explorerPrice=explorer.querySelector('[data-expprice]');
      var explorerAccent=explorer.querySelector('.rccs-exp__accent');
      var explorerActive=0;
      var explorerTimer=0;
      var swatchesGroupForWarm=explorer.querySelector('[data-expswatches]');
      var explorerFade=[explorerTag,explorerName,explorerDescription,explorerPrice];
      explorerFade.forEach(function(el){if(el)el.style.transition='opacity .25s ease';});

      function pad(number){return (number<10?'0':'')+number;}

      function safeHref(value){
        if(!value)return '#';
        try{
          var url=new URL(value,window.location.origin);
          if(['http:','https:','mailto:','tel:'].indexOf(url.protocol)!==-1)return value;
        }catch(error){}
        return '#';
      }

      /* Non-first stage images ship with their candidates parked in data-* so the browser does
         not fetch four full-size photos at once; promote on first use. */
      function promoteMedia(index){
        var media=explorer.querySelector('[data-expmedia][data-c="'+index+'"]');
        var img=media&&media.querySelector('img[data-srcset]');
        if(!img)return;
        if(img.dataset.sizes)img.setAttribute('sizes',img.dataset.sizes);
        img.setAttribute('srcset',img.dataset.srcset);
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-sizes');
      }

      function selectColourway(index,moveFocus){
        if(!swatches.length)return;
        explorerActive=((index%swatches.length)+swatches.length)%swatches.length;
        var button=swatches[explorerActive];
        promoteMedia(explorerActive);
        explorerMedia.forEach(function(media){
          var selected=+media.dataset.c===explorerActive;
          media.classList.toggle('is-on',selected);
          media.setAttribute('aria-hidden',selected?'false':'true');
        });
        swatches.forEach(function(swatch,swatchIndex){
          var selected=swatchIndex===explorerActive;
          swatch.classList.toggle('is-on',selected);
          swatch.setAttribute('aria-pressed',selected?'true':'false');
        });
        if(moveFocus)button.focus();
        if(explorerAccent)explorerAccent.style.width='0';
        explorerFade.forEach(function(el){if(el)el.style.opacity='0';});
        if(explorerTimer){
          window.clearTimeout(explorerTimer);
          timers.delete(explorerTimer);
        }
        explorerTimer=later(function(){
          if(explorerTag)explorerTag.textContent=button.dataset.tag||'New Colourway';
          if(explorerName)explorerName.textContent=button.dataset.name||'';
          if(explorerDescription)explorerDescription.textContent=button.dataset.text||'';
          if(explorerPrice)explorerPrice.textContent=button.dataset.price||'';
          if(explorerShop){
            var href=safeHref(button.dataset.link);
            explorerShop.textContent='Shop '+(button.dataset.name||'colourway');
            explorerShop.setAttribute('href',href);
            if(href==='#'){
              explorerShop.setAttribute('aria-disabled','true');
              explorerShop.setAttribute('tabindex','-1');
            }else{
              explorerShop.removeAttribute('aria-disabled');
              explorerShop.removeAttribute('tabindex');
            }
          }
          if(explorerCount)explorerCount.textContent=pad(explorerActive+1);
          explorerFade.forEach(function(el){if(el)el.style.opacity='1';});
          if(explorerAccent)explorerAccent.style.width='56px';
        },200);
      }

      swatches.forEach(function(swatch,index){
        listen(swatch,'click',function(){selectColourway(index,false);});
        listen(swatch,'keydown',function(event){
          var next=null;
          if(event.key==='ArrowRight'||event.key==='ArrowDown')next=index+1;
          if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=index-1;
          if(event.key==='Home')next=0;
          if(event.key==='End')next=swatches.length-1;
          if(next!==null){
            event.preventDefault();
            selectColourway(next,true);
          }
        });
      });

      /* First hover or focus anywhere in the swatch group means the visitor is about to browse:
         promote the remaining images then, so the swap is instant without a load-time cost. */
      var mediaWarmed=false;
      function warmMedia(){
        if(mediaWarmed)return;
        mediaWarmed=true;
        explorerMedia.forEach(function(m){promoteMedia(+m.dataset.c);});
      }
      if(swatchesGroupForWarm){
        listen(swatchesGroupForWarm,'pointerenter',warmMedia,{once:true});
        listen(swatchesGroupForWarm,'focusin',warmMedia,{once:true});
      }

      /* On mobile the swatches sit directly under the photo, so a colourway can be
         changed while looking at it. Desktop keeps them in the info column. Moving the
         node keeps every listener and the swatches NodeList intact, and the swatches are
         already JS-only (hidden by .rccs:not(.rccs--js)), so the no-JS view is unaffected. */
      var swatchGroup=explorer.querySelector('[data-expswatches]');
      var swatchHome=swatchGroup&&swatchGroup.parentNode;
      var expStage=explorer.querySelector('[data-expstage]');
      function placeSwatches(){
        if(!swatchGroup||!swatchHome||!expStage)return;
        if(mobileQuery.matches){
          if(swatchGroup.previousElementSibling!==expStage)expStage.insertAdjacentElement('afterend',swatchGroup);
        }else if(swatchGroup.parentNode!==swatchHome){
          swatchHome.appendChild(swatchGroup);
        }
      }
      placeSwatches();
      listen(mobileQuery,'change',placeSwatches);
      /* matchMedia 'change' is not reliable everywhere, so the resize path re-checks too. */
      placeSwatchesForBreakpoint=placeSwatches;
    }

    var anatomy=root.querySelector('[data-anatomy]');
    if(anatomy){
      var hotspots=anatomy.querySelectorAll('.rccs-hotspot');
      var anatomyTitle=anatomy.querySelector('[data-anattitle]');
      var anatomyBody=anatomy.querySelector('[data-anatbody]');
      var anatomyAccent=anatomy.querySelector('.rccs-anat__accent');
      var anatomyTimer=0;
      if(anatomyTitle)anatomyTitle.style.transition='opacity .25s ease';
      if(anatomyBody)anatomyBody.style.transition='opacity .25s ease';

      var anatomyFocusTarget=anatomy.querySelector('.rccs-anat')||anatomy;

      /* Pull the whole anatomy block into view so a tapped point isn't half off-screen. */
      var anatomyStage=anatomy.querySelector('.rccs-anat__stage');

      /* Keep the whole block on screen so more points can be tapped without scrolling back.
         Centre it when it fits; when the merchant's image makes it taller than the viewport,
         align the TOP - the image and its points stay fully visible and the text follows
         below, which is the wrong way round if you centre the text panel instead. */
      function focusAnatomy(){
        var rect=anatomyFocusTarget.getBoundingClientRect();
        var viewportHeight=window.innerHeight;
        var current=window.scrollY;
        var absoluteTop=rect.top+current;
        var offset=topObstruction();
        var room=viewportHeight-offset;
        var slack=room-rect.height;
        /* Centre it in whatever room is left when it fits - even a few px of slack is enough,
           so do NOT reserve headroom before the fit test or a nearly-fitting block gets
           top-aligned and its last line hangs below the fold. Taller than the screen: put the
           image and its points first, text continues below. */
        var top=slack>0
          ? absoluteTop-offset-(slack/2)
          : absoluteTop-offset;
        /* Never push the tappable image off the top. */
        if(anatomyStage){
          var stageTop=anatomyStage.getBoundingClientRect().top+current-offset;
          top=Math.min(top,stageTop);
        }
        top=Math.max(top,0);
        if(Math.abs(top-current)<40)return;
        if(reduce){window.scrollTo(0,top);return;}
        try{window.scrollTo({top:top,behavior:'smooth'});}
        catch(error){window.scrollTo(0,top);return;}
        /* Some in-app webviews (Instagram/Facebook/TikTok) silently ignore behavior:'smooth'.
           If nothing actually moved, jump instead of leaving the visitor where they were. */
        later(function(){
          if(Math.abs(window.scrollY-current)<4)window.scrollTo(0,top);
        },240);
      }

      function selectHotspot(hotspot,userInitiated){
        hotspots.forEach(function(item){
          var selected=item===hotspot;
          item.classList.toggle('is-on',selected);
          item.setAttribute('aria-pressed',selected?'true':'false');
        });
        if(userInitiated)focusAnatomy();
        if(anatomyAccent)anatomyAccent.style.width='0';
        if(anatomyTitle)anatomyTitle.style.opacity='0';
        if(anatomyBody)anatomyBody.style.opacity='0';
        if(anatomyTimer){
          window.clearTimeout(anatomyTimer);
          timers.delete(anatomyTimer);
        }
        anatomyTimer=later(function(){
          if(anatomyTitle)anatomyTitle.textContent=hotspot.dataset.title||'';
          if(anatomyBody)anatomyBody.textContent=hotspot.dataset.text||'';
          if(anatomyTitle)anatomyTitle.style.opacity='1';
          if(anatomyBody)anatomyBody.style.opacity='1';
          if(anatomyAccent)anatomyAccent.style.width='50px';
        },180);
      }

      hotspots.forEach(function(hotspot){
        listen(hotspot,'click',function(){selectHotspot(hotspot,true);});
      });
      /* Theme-editor selection must not hijack the merchant's scroll position. */
      selectHotspotSilently=function(hotspot){selectHotspot(hotspot,false);};
    }

    function formatInteger(value){
      try{return Math.round(value).toLocaleString(document.documentElement.lang||undefined);}
      catch(error){return Math.round(value).toLocaleString('en-US');}
    }

    function animateNumber(el){
      var target=parseFloat(el.dataset.count);
      if(!Number.isFinite(target)||target<=0)return;
      var decimals=Math.max(0,Math.min(2,+(el.dataset.dec||0)));
      var suffix=el.dataset.suffix||'';
      var prefix=el.dataset.prefix||'';
      var duration=1500;
      var start=null;
      function format(value){return prefix+(decimals?value.toFixed(decimals):formatInteger(value))+suffix;}
      if(reduce){
        el.textContent=format(target);
        return;
      }
      function step(time){
        if(reduce){
          el.textContent=format(target);
          return;
        }
        if(start===null)start=time;
        var progress=Math.min((time-start)/duration,1);
        var eased=1-Math.pow(1-progress,3);
        el.textContent=format(target*eased);
        if(progress<1)frame(step);
        else el.textContent=format(target);
      }
      frame(step);
    }

    var countElements=root.querySelectorAll('.rccs-num');
    if(countElements.length){
      reduceHandlers.push(function(isReduced){
        if(isReduced)countElements.forEach(animateNumber);
      });
      if('IntersectionObserver' in window){
        var countObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              animateNumber(entry.target);
              countObserver.unobserve(entry.target);
            }
          });
        },{threshold:.6});
        observers.push(countObserver);
        countElements.forEach(function(el){countObserver.observe(el);});
      }else{
        countElements.forEach(animateNumber);
      }
    }

    root.querySelectorAll('[data-media-scope]').forEach(function(scope){
      var videos=scope.querySelectorAll('video');
      var motionPaused=reduce;
      var inView=true;
      var syncQueued=false;

      function videoHidden(video){
        var holder=video.closest('.rccs-bgvideo');
        return holder&&window.getComputedStyle(holder).display==='none';
      }

      function syncVideos(){
        videos.forEach(function(video){
          if(motionPaused||document.hidden||!inView||videoHidden(video)){
            video.pause();
          }else{
            var promise=video.play();
            if(promise&&promise.catch)promise.catch(function(){});
          }
        });
      }

      function requestSync(){
        if(syncQueued)return;
        syncQueued=true;
        frame(function(){syncQueued=false;syncVideos();});
      }

      if(videos.length&&'IntersectionObserver' in window){
        inView=false;
        var scopeObserver=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){inView=entry.isIntersecting;});
          syncVideos();
        },{rootMargin:'120px'});
        scopeObserver.observe(scope);
        observers.push(scopeObserver);
      }

      videos.forEach(function(video){
        listen(video,'play',function(){
          if(motionPaused||document.hidden||!inView||videoHidden(video))video.pause();
        });
      });
      listen(window,'resize',requestSync,{passive:true});
      listen(document,'visibilitychange',syncVideos);
      reduceHandlers.push(function(isReduced){
        motionPaused=isReduced;
        syncVideos();
      });
      syncVideos();
    });

    var progress=root.querySelector('[data-progress]');
    var topbar=root.querySelector('[data-topbar]');
    var heroBackground=root.querySelector('[data-herobg]');
    var heroFits=!!root.querySelector('[data-hero-fit]');
    var scrolling=false;
    var scrollFrame=0;

    function onScroll(){
      var scrollTop=window.scrollY;
      var viewportHeight=window.innerHeight;
      var rootRect=root.getBoundingClientRect();
      var rootTop=rootRect.top+scrollTop;
      var rootTravel=Math.max(root.offsetHeight-viewportHeight,1);
      var rootProgress=Math.min(Math.max((scrollTop-rootTop)/rootTravel,0),1);
      var rootActive=rootRect.bottom>0&&rootRect.top<viewportHeight;
      if(progress){
        progress.style.transform='scaleX('+rootProgress+')';
        progress.style.opacity=rootActive?'1':'0';
      }
      if(topbar){
        var topbarVisible=rootActive&&(scrollTop-rootTop)>viewportHeight*.85;
        if(!topbarVisible&&topbar.contains(document.activeElement))document.activeElement.blur();
        topbar.classList.toggle('is-show',topbarVisible);
        topbar.toggleAttribute('inert',!topbarVisible);
        topbar.setAttribute('aria-hidden',topbarVisible?'false':'true');
      }
      /* No parallax when the hero is fitting its media: shifting contained media would crop the
         thing the toggle exists to show whole. */
      if(heroBackground)heroBackground.style.transform=(reduce||heroFits)?'':'translateY('+(Math.max(scrollTop-rootTop,0)*.14)+'px)';
      if(craft&&selectCraftStep&&craftPinned===null&&!mobileQuery.matches){
        var craftRect=craft.getBoundingClientRect();
        var craftTravel=craft.offsetHeight-viewportHeight;
        if(craftTravel>0){
          var craftProgress=Math.min(Math.max((-craftRect.top)/craftTravel,0),.999);
          selectCraftStep(Math.floor(craftProgress*craftSteps.length));
        }
      }
    }

    function requestScroll(){
      if(scrolling)return;
      scrolling=true;
      scrollFrame=frame(function(){
        onScroll();
        scrolling=false;
      });
    }

    /* Breakpoint-dependent DOM placement, re-checked on resize/rotation. Called directly
       rather than through frame(): it reads no geometry, so it cannot cause layout thrash,
       and an rAF hop would stall it whenever the page is not being painted. */
    function requestLayout(){
      if(placeSwatchesForBreakpoint)placeSwatchesForBreakpoint();
      syncScrollOffset();
    }

    syncScrollOffset();
    listen(window,'scroll',requestScroll,{passive:true});
    listen(window,'resize',requestScroll,{passive:true});
    listen(window,'resize',requestLayout,{passive:true});
    listen(window,'orientationchange',requestLayout);
    onScroll();

    var controller={
      selectBlock:function(target){
        if(!target)return;
        target.classList.add('is-in');
        if(target.matches('.rccs-craft__step')&&selectCraftStep){
          craftPinned=+target.dataset.step;
          selectCraftStep(craftPinned);
        }
        if(target.matches('.rccs-swatch'))target.click();
        if(target.matches('.rccs-hotspot')){
          if(selectHotspotSilently)selectHotspotSilently(target);
          else target.click();
        }
      },
      deselectBlock:function(){craftPinned=null;},
      destroy:function(){
        if(destroyed)return;
        destroyed=true;
        cleanups.forEach(function(cleanup){cleanup();});
        observers.forEach(function(observer){observer.disconnect();});
        timers.forEach(function(id){window.clearTimeout(id);});
        frames.forEach(function(id){window.cancelAnimationFrame(id);});
        if(scrollFrame)window.cancelAnimationFrame(scrollFrame);
        if(topbar){
          topbar.classList.remove('is-show');
          topbar.setAttribute('aria-hidden','true');
          topbar.setAttribute('inert','');
        }
        root.classList.remove('rccs--js');
        instances.delete(root);
      }
    };

    instances.set(root,controller);
  }

  function initWithin(scope){rootsWithin(scope).forEach(init);}
  function destroyWithin(scope){
    rootsWithin(scope).forEach(function(root){
      var controller=instances.get(root);
      if(controller)controller.destroy();
    });
  }

  window.RCCSCollectionStory={initWithin:initWithin,destroyWithin:destroyWithin};
  initWithin(document);

  document.addEventListener('shopify:section:load',function(event){initWithin(event.target);});
  document.addEventListener('shopify:section:unload',function(event){destroyWithin(event.target);});
  document.addEventListener('shopify:block:select',function(event){
    var root=event.target&&event.target.closest&&event.target.closest('[data-rccs]');
    var controller=root&&instances.get(root);
    if(controller)controller.selectBlock(event.target);
  });
  document.addEventListener('shopify:block:deselect',function(event){
    var root=event.target&&event.target.closest&&event.target.closest('[data-rccs]');
    var controller=root&&instances.get(root);
    if(controller&&controller.deselectBlock)controller.deselectBlock();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
